import { NgModule } from '@angular/core';
import { LocalService, ScriptService, BlackListService, ClientService, BlackListHistoricService, DocumentService, ProviderService, TagsUserService, PermissionService, AccountService, SidebarService, NoticeService } from './index';
import { ServicesHelperService } from './services-helper.service';
import { CatalogsService } from './catalogs.service';
import { ContractEntityService } from './contract-entity.service';
import { ZorbekSepomexService } from './zorbek-sepomex.service';
import { VulnerableActivitiesService } from './vulnerable-activities.service';
import { RestrictionService } from './restriction.service';
import { HttpService } from './http-service';
import { SubjectObligedService } from './subject-obliged-service';
import { TagsService } from './tags.service';
import { SaveContractService } from './save-contract.service';

@NgModule({
  providers: [
    LocalService,
    ServicesHelperService,
    ScriptService,
    CatalogsService,
    BlackListService,
    ClientService,
    BlackListHistoricService,
    DocumentService,
    ProviderService,
    ContractEntityService,
    ZorbekSepomexService,
    VulnerableActivitiesService,
    RestrictionService,
    TagsUserService,
    HttpService,
    SubjectObligedService,
    TagsService,
    PermissionService,
    AccountService,
    SidebarService,
    NoticeService,
    SaveContractService
  ],
})
export class ServicesModule {}
